import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as _ from 'underscore';

import Button from 'material-ui/Button';
import { CircularProgress } from 'material-ui/Progress';
import ArrowDropIcon from '@material-ui/icons/ArrowDropDown';

import CalendarSwitcher from './CalendarSwitcher';
import GroupIcon from '../../common/GroupIcon';

import * as AppState from '../../../state/reducer/app/appState';
import * as ClipboardState from '../../../state/reducer/clipboard/clipboard';
import * as ProgramTypes from '../../../state/reducer/calendar/programTypes';

import Console from '../../../lib/debug';

class CalendarTitle extends Component {
    state = {
        switcherOpen: false
    };

    cancel() {
        this.setState({ switcherOpen: false });
        ClipboardState.enableCalendarHotkeys();
    }

    openSwitcher() {
        this.setState({ switcherOpen: true });
        ClipboardState.disableCalendarHotkeys();
    }

    onSuggestionSelected(id) {
        let isAthleteCalendar = ProgramTypes.isCoachAthleteCalendar(
            this.props.programType
        );
        if (!isAthleteCalendar && id === this.props.programId) return;
        if (isAthleteCalendar && id === this.props.athleteId) return;

        const prefix = ProgramTypes.convertToString(this.props.programType);
        const path = `/${prefix}/${id}/${this.props.year}/${this.props.month}`;

        return AppState.navigate(path);
    }

    filterOwned = options => {
        if (AppState.isAdmin()) {
            return options;
        }

        return options.filter(option => {
            let userId = option.user_id || option.owner_user_id;
            return (
                userId === this.props.loggedInUser.id ||
                option.org_id === this.props.loggedInUser.org_id
            );
        });
    };

    getOptions = () => {
        switch (this.props.programType) {
            case ProgramTypes.TYPES.TEAM:
                return this.filterOwned(this.props.teamOptions);
            case ProgramTypes.TYPES.CALENDAR:
                return this.filterOwned(this.props.calendarOptions);
            case ProgramTypes.TYPES.FIXED:
                return this.filterOwned(this.props.programOptions);
            case ProgramTypes.TYPES.COACH_ATHLETE_CALENDAR:
                return this.props.athleteOptions;
            default:
                return [];
        }
    };

    getTitle = () => {
        if (!ProgramTypes.isCoachAthleteCalendar(this.props.programType)) {
            return this.props.team.title;
        }
        let athlete = this.currentAthlete();
        return athlete ? athlete.fullName : '';
    };

    getInvitedAthlete = () => {
        if (ProgramTypes.isInvitedAthleteCalendar(this.props.programType)) {
            let athlete = this.currentInvited();
            return athlete ? athlete.email + ' ' + athlete.fullName : '';
        }
    };

    currentInvited = () =>
        _.find(
            this.props.invitedOptions,
            invited => invited.id === this.props.athleteId
        );

    currentAthlete = () =>
        _.find(
            this.props.athleteOptions,
            athlete => athlete.id === this.props.athleteId
        );

    getIcon = () => {
        if (!ProgramTypes.isCoachAthleteCalendar(this.props.programType)) {
            return this.props.team.logo;
        }

        let athlete = this.currentAthlete();
        return athlete ? athlete.image_profile : this.props.team.logo;
    };

    getSuggestionValue(suggestion) {
        return ProgramTypes.getAthleteValue(
            this.props.programType,
            suggestion.fullName,
            suggestion.title
        );
    }

    render() {
        Console.render('Calendar Title');

        if (ProgramTypes.isInvitedAthleteCalendar(this.props.programType)) {
            return (
                <div className="cal-title-button invited">
                    <h3 className="invert-color">{this.getInvitedAthlete()}</h3>
                </div>
            );
        }

        if (this.state.switcherOpen) {
            return (
                <CalendarSwitcher
                    cancel={this.cancel.bind(this)}
                    onSuggestionSelected={this.onSuggestionSelected.bind(this)}
                    getSuggestionValue={this.getSuggestionValue.bind(this)}
                    options={this.getOptions()}
                />
            );
        }

        if (!this.props.team) {
            return <CircularProgress />;
        }

        return (
            <div className="cal-title-button">
                <Button
                    onClick={this.openSwitcher.bind(this)}
                    className="nav-text-button"
                >
                    <GroupIcon src={this.getIcon()} />
                    <h3 className="invert-color">{this.getTitle()}</h3>
                    <ArrowDropIcon className="invert-color" />
                </Button>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        team: state.calendar.infoTree.team,
        programType: state.calendar.infoTree.programType,
        programId: state.calendar.infoTree.programId,
        athleteId: state.calendar.infoTree.athleteId,
        calendarOptions: state.library.calendarProgramsTree,
        teamOptions: state.library.teamsTree,
        athleteOptions: state.library.athletesTree,
        invitedOptions: state.library.invitedAthletesTree,
        programOptions: state.library.fixedLengthProgramsTree,
        month: state.calendar.infoTree.month,
        year: state.calendar.infoTree.year,
        loggedInUser: state.app.loggedInUser
    };
};

export default connect(mapStateToProps)(CalendarTitle);



// WEBPACK FOOTER //
// ./src/view/calendar/components/CalendarTitle.jsx